import { merge } from 'lodash'
import contentSettings from '~/sites/shop/content.settings'

const overloadSettings = {}

export default merge(contentSettings, overloadSettings)
